module.exports = __webpack_public_path__ + "img/project-1.56e21281.jpg";